import { Box, BoxProps } from '@chakra-ui/react';
import React from 'react';

export const CmBox: React.FC<BoxProps> = ({ children, ...rest }) => {
  return <Box {...rest}>{children}</Box>;
};
